const FILES_BURGDEV_ORIGIN = 'https://files.burgdev.ru'

export function resolveFilesBurgdevUrl(
  raw: string | null | undefined
): string {
  const s = typeof raw === 'string' ? raw.trim() : ''
  if (!s) {
    return ''
  }
  if (/^https?:\/\//i.test(s) || s.startsWith('//')) {
    return s
  }
  if (s.startsWith('data:') || s.startsWith('blob:')) {
    return s
  }
  const base = FILES_BURGDEV_ORIGIN.replace(/\/+$/, '')
  return `${base}/${s.replace(/^\/+/, '')}`
}

export function resolvedRemoteImageSrc(
  remoteUrl: string | null | undefined
): string | undefined {
  if (!remoteUrl?.trim()) {
    return undefined
  }
  const out = resolveFilesBurgdevUrl(remoteUrl)
  return out || undefined
}
const FILES_BURGDEV_ORIGIN = 'https://files.burgdev.ru'

export function resolveFilesBurgdevUrl(
  raw: string | null | undefined
): string {
  const s = typeof raw === 'string' ? raw.trim() : ''
  if (!s) {
    return ''
  }
  if (/^https?:\/\//i.test(s) || s.startsWith('//')) {
    return s
  }
  if (s.startsWith('data:') || s.startsWith('blob:')) {
    return s
  }
  const base = FILES_BURGDEV_ORIGIN.replace(/\/+$/, '')
  return `${base}/${s.replace(/^\/+/, '')}`
}

export function resolvedRemoteImageSrc(
  remoteUrl: string | null | undefined
): string | undefined {
  if (!remoteUrl?.trim()) {
    return undefined
  }
  const out = resolveFilesBurgdevUrl(remoteUrl)
  return out || undefined
}
